<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-batch-point-upload-tool">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <div class="row">
              <div class="col-sm-6 col-md-6">
                <h4>User Point Batch Process Manager</h4>
              </div>
              <div class="col-sm-6 col-md-6 align-right">
                <a href="/admin-points-faq" target="_blank"
                  >Frequently Asked Questions</a
                >
              </div>
            </div>
            <p class="my-2">
              This tool will allow you to update points on large amounts of
              users. You will need an
              <a @click="saveTemplate()">Excel template</a> to fill employees'
              username, awarded points and program_id.
            </p>
            <hr />
            <a-spin :spinning="fileUploadStatus === 'saving'">
              <div
                class="col-sm-5 col-md-5 card summary"
                v-if="
                  file &&
                  (fileUploadStatus === 'uploaded' ||
                    fileUploadStatus === 'saving')
                "
              >
                <div class="m-3">
                  <h4>File Upload Results</h4>
                  <hr />
                  <p>
                    File
                    <strong>{{ lastUploads.at(-1).file.name }}</strong> uploaded
                    on <strong>{{ lastUploads.at(-1).uploadTime }}</strong>
                  </p>
                  <hr />
                  <div
                    v-if="
                      lastUploads
                        .at(-1)
                        .uploadResult.batchUserPoints.some(
                          ({ action_type }) => action_type === 'ok'
                        )
                    "
                  >
                    <label>Points to be awarded</label>
                    <p>
                      <strong>
                        {{ getPoints() }}
                      </strong>
                      points will be awarded to
                      <strong>
                        {{
                          lastUploads
                            .at(-1)
                            .uploadResult.batchUserPoints.filter(
                              ({ action_type }) => action_type === "ok"
                            ).length
                        }}</strong
                      >
                      unlocked, existing users.
                    </p>
                    <hr />
                    <!--<div v-if="stripeCustomerId" class="">
                      <h5>
                        You will be charged for the points using the payment
                        method on file
                      </h5>
                      <p>
                        Price: $
                        {{ getPoints() / ratio }}
                      </p>
                      <p>
                        Uhallocated Deposit that will be used:
                        {{ unallocDeposit }}
                      </p>
                      <p class="font-weight-bold">
                        Final Cost: ${{
                          getPoints() / ratio - unallocDeposit > 0
                            ? getPoints() / ratio - unallocDeposit
                            : 0
                        }}
                      </p>
                    </div>-->
                  </div>
                  <div
                    v-if="
                      lastUploads
                        .at(-1)
                        .uploadResult.batchUserPoints.some(
                          ({ action_type }) => action_type === 'unlock'
                        )
                    "
                  >
                    <label>Action needed on following users</label>
                    <div><label>Locked users</label></div>
                    <p>
                      Please select desired action by using check boxes to
                      indicate if you would like to unlock each user, and if
                      unlocked, if you would like to reset their points to 0
                      before adding new points uploaded in this session.
                    </p>
                    <div>
                      <a-table
                        :columns="usersToUnlockFields"
                        :data-source="usersToUnlock"
                        :row-key="(record) => record.id"
                        :pagination="usersToUnlockPagination"
                      >
                        <span slot="reset_points">
                          <a-checkbox :disabled="true" />
                        </span>
                        <span slot="unlock" slot-scope="text, record">
                          <a-checkbox
                            :checked="unlockedUsers.includes(record.id)"
                            @change="setUnlockedUsers(record.id)"
                          />
                        </span>
                      </a-table>
                    </div>
                  </div>
                  <div
                    v-if="
                      lastUploads
                        .at(-1)
                        .uploadResult.batchUserPoints.some(
                          ({ action_type }) => action_type === 'create'
                        )
                    "
                  >
                    <hr />
                    <label>New users</label>
                    <p>
                      The following users have incomplete data. You can create
                      them now, or at a later time in the user creating page
                    </p>
                    <div>
                      <a-form :form="createUserForm" layout="inline">
                        <a-table
                          :columns="usersToCreateFields"
                          :data-source="usersToCreate"
                          :row-key="(record) => record.id"
                          :pagination="usersToCreatePagination"
                        >
                          <span slot="create" slot-scope="text, record">
                            <a-form-item v-if="record.editable">
                              <a-checkbox
                                style="margin: -5px 0"
                                v-decorator="[
                                  'create',
                                  {
                                    valuePropName: 'checked',
                                    initialValue: text,
                                  },
                                ]"
                              />
                            </a-form-item>
                            <a-checkbox
                              v-else
                              :checked="text"
                              :disabled="true"
                            />
                          </span>
                          <template
                            v-for="col in ['last_name', 'first_name', 'email']"
                            :slot="col"
                            slot-scope="text, record"
                          >
                            <a-form-item v-if="record.editable" :key="col">
                              <a-input
                                :type="col === 'email' ? 'email' : 'text'"
                                v-decorator="[
                                  col,
                                  {
                                    rules: [
                                      {
                                        required: true,
                                        message: `${col
                                          .split('_')
                                          .map((word) => {
                                            return (
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1).toLowerCase()
                                            );
                                          })
                                          .join(' ')} field is required`,
                                      },
                                    ],
                                    initialValue: text,
                                  },
                                ]"
                              />
                            </a-form-item>
                            <span v-else :key="col" :title="text">
                              {{ text }}
                            </span>
                          </template>
                          <template slot="company" slot-scope="text, record">
                            <a-form-item v-if="record.editable">
                              <a-select
                                style="margin: -5px 0"
                                :options="
                                  authorizedClients.map(
                                    ({ clientId, clientName }) => ({
                                      value: clientId.toString(),
                                      label: clientName,
                                    })
                                  )
                                "
                                v-decorator="[
                                  'client_id',
                                  {
                                    rules: [
                                      {
                                        required: true,
                                        message: 'Company is required',
                                      },
                                    ],
                                    initialValue: text,
                                  },
                                ]"
                            /></a-form-item>
                            <span
                              v-else
                              :title="
                                authorizedClients.find(
                                  ({ clientId }) => clientId.toString() === text
                                )
                                  ? authorizedClients.find(
                                      ({ clientId }) =>
                                        clientId.toString() === text
                                    ).clientName
                                  : text
                              "
                            >
                              {{
                                authorizedClients.find(
                                  ({ clientId }) => clientId.toString() === text
                                )
                                  ? authorizedClients.find(
                                      ({ clientId }) =>
                                        clientId.toString() === text
                                    ).clientName
                                  : text
                              }}
                            </span>
                          </template>
                          <template slot="points" slot-scope="text, record">
                            <a-form-item v-if="record.editable">
                              <a-input-number
                                style="margin: -5px 0"
                                v-decorator="[
                                  'points',
                                  {
                                    rules: [
                                      {
                                        required: true,
                                        message: 'Poinits is required',
                                      },
                                    ],
                                    initialValue: text,
                                  },
                                ]"
                            /></a-form-item>
                            <span
                              v-else-if="record.points < 0"
                              class="badge badge-danger"
                              >{{ record.points.toFixed }}</span
                            >
                            <span
                              v-else-if="record.points >= 0"
                              class="badge badge-success"
                              >{{ record.points }}</span
                            >
                          </template>
                          <template slot="operation" slot-scope="text, record">
                            <div class="editable-row-operations">
                              <span v-if="record.editable">
                                <a @click="save(record.id)">Save</a>
                                <a-popconfirm
                                  title="Sure to cancel?"
                                  @confirm="() => cancel(record.id)"
                                >
                                  <a>Cancel</a>
                                </a-popconfirm>
                              </span>
                              <span v-else>
                                <a
                                  :disabled="editusersToCreateId !== ''"
                                  @click="() => edit(record.id)"
                                  >Edit</a
                                >
                              </span>
                            </div>
                          </template>
                        </a-table>
                      </a-form>
                    </div>
                  </div>
                  <div class="fileUploadResultAction">
                    <button
                      class="btn btn-secondary btn-lg btn-sm-block mr-3 my-2"
                      @click="cancelFileSave()"
                    >
                      Cancel
                    </button>
                    <button
                      class="btn btn-primary btn-lg btn-sm-block mr-1 my-2"
                      :disabled="!saveUploadLoading && editusersToCreateId !== ''"
                      @click="savePointsUploadFile()"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </a-spin>
            <div
              class="col-sm-5 col-md-5 card summary"
              v-if="file && fileUploadStatus === 'saved'"
            >
              <div class="m-3">
                <h4>Batch process successful</h4>
                <hr />
                <p>
                  File
                  <strong>{{ lastUploads.at(-1).file.name }}</strong> successful
                  on <strong>{{ lastUploads.at(-1).saveTime }}</strong>
                </p>
                <hr />
                <label
                  >{{ lastUploads.at(-1).saveResult.points_awarded }} points
                  awarded to
                  {{ lastUploads.at(-1).saveResult.users_awarded }} users</label
                >
                <hr />
                <label
                  >{{ lastUploads.at(-1).saveResult.users_unlocked }} User(s)
                  unlocked</label
                >
                <hr />
                <label
                  >{{ lastUploads.at(-1).saveResult.users_created }} User(s)
                  created</label
                >

                <hr />
                <div class="fileUploadResultAction">
                  <button
                    class="btn btn-secondary btn-lg btn-sm-block mr-1 my-2"
                    @click="closeFileSave()"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
            <a-spin :spinning="fileUploadStatus === 'uploading'">
              <div class="row my-2">
                <div class="col-sm-7 col-md-7">
                  <label>Upload User Points File</label>
                  <p class="my-2">
                    Large files can take up to <strong>10 minutes</strong> to
                    upload and process. Once uploaded, you will get notification
                    of the results in your email inbox. Upload only the
                    <a @click="saveTemplate()">provided Excel template</a>.
                  </p>
                  <div class="card">
                    <div class="p-3">
                      <a-upload
                        accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                        :showUploadList="{
                          showPreviewIcon: false,
                          showRemoveIcon: false,
                        }"
                        :before-upload="beforeUpload"
                        :file-list="fileList"
                      >
                        <a-button> Select File </a-button>
                      </a-upload>
                    </div>
                  </div>
                  <b-check class="mt-2" v-model="allowDups">
                    Allow Duplicate Users and Program IDs</b-check
                  >
                  <button
                    class="btn btn-primary btn-lg btn-sm-block mr-1 my-2"
                    :disabled="!file"
                    @click="showUploadConfirm = true"
                  >
                    {{ fileUploadStatus === "uploading" ? "Processing..." : "Upload User Points" }}
                  </button>

                  <hr />
                  <div
                    v-if="previousUpload.data && previousUpload.data.length > 0"
                  >
                    <div class="lastUploadsHeader">
                      <label>Last uploads </label>
                      <a @click="toggleAllUpload()">
                        View all Uploads <font-awesome-icon icon="angle-down" />
                      </a>
                    </div>
                    <a-spin :spinning="previousUpload.loading">
                      <div
                        v-for="upload in previousUpload.data"
                        :key="upload.id"
                        class="uploadResult"
                      >
                        <div
                          class="results-row d-flex"
                          style="align-items: center"
                        >
                          <a-icon
                            type="clock-circle"
                            theme="filled"
                            v-if="upload.is_in_progress"
                          />
                          <a-icon
                            type="check-circle"
                            style="color: rgb(40, 167, 69)"
                            theme="filled"
                            v-else
                          />

                          <div
                            :title="upload.file_name"
                            :style="
                              upload.is_in_progress
                                ? 'color:black;'
                                : 'color: #1890ff; cursor: pointer;'
                            "
                            @click="downloadExcel(upload)"
                          >
                            {{ upload.file_name }}
                          </div>
                          <div>{{ parseInt(upload.file_size / 1000) }} kb</div>
                          <div :title="upload.upload_date">
                            {{
                              moment(upload.upload_date).format(
                                "MM/DD/YYYY hh:mm A"
                              )
                            }}
                          </div>
                          <div>
                            <a v-b-toggle="upload.id.toString()">
                              summary <font-awesome-icon icon="angle-down" />
                            </a>
                          </div>
                        </div>
                        <b-collapse class="card" :id="upload.id.toString()">
                          <div class="p-3">
                            <strong>{{ upload.points_awarded }}</strong> points
                            awarded to
                            <strong>{{ upload.users_awarded }}</strong> users.
                            <strong>{{ upload.users_unlocked }} </strong> users
                            unlocked
                            <strong>{{ upload.users_created }}</strong> new
                            users created.
                          </div>
                        </b-collapse>
                      </div>
                    </a-spin>
                  </div>
                </div>
                <div class="col-sm-5 col-md-5 card summary">
                  <div class="m-3">
                    <label>Get Excel Template</label>
                    <div class="display-flex my-2">
                      <a @click="saveTemplate()">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 384 512"
                          width="14px"
                          height="14px"
                          style="fill: #3782f3"
                        >
                          <path
                            d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                          />
                        </svg>
                        Download Blank Template
                      </a>
                    </div>
                    <hr />
                    <div class="display-flex my-2">
                      <a v-b-toggle.collapse-a>
                        <font-awesome-icon icon="angle-down" />
                        Instructions To Fill Template
                      </a>
                    </div>
                    <b-collapse id="collapse-a" class="mt-2">
                      <b-card
                        >Please make sure that the xls spreadsheet you upload
                        follows the provided
                        <a @click="saveTemplate()"
                          ><i class="fa-solid fa-file"></i> template</a
                        >:</b-card
                      >
                      <b-card
                        >it must contain <b>username</b>, <b>program_id</b> and
                        <b>points</b> columns; the
                        <b>transaction_comments</b> is optional.</b-card
                      >
                      <b-card
                        >If you are unsure of how to use the template, check out
                        the
                        <a href="/admin-points-faq" target="_blank"
                          >Frequently Asked Questions</a
                        ></b-card
                      >
                    </b-collapse>
                    <hr />
                    <div class="my-2">
                      <label>Authorized Companies/Locations</label>
                      <ul style="list-style-type: none">
                        <li
                          v-for="Client in authorizedClients"
                          :key="Client.client_id"
                        >
                          <div class="row">
                            <div class="col-sm-6 col-lg-6 col-md-6">
                              <p>{{ Client.clientName }}</p>
                            </div>
                            <div class="col-sm-6 col-lg-6 col-md-6">
                              <p>ID&nbsp;{{ Client.clientId }}</p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </a-spin>
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
    <a-modal
      :visible="allUpload.visible"
      title="All Uploads"
      width="800px"
      :footer="null"
      @cancel="toggleAllUpload()"
    >
      <a-spin :spinning="allUpload.loading">
        <div
          v-for="upload in allUpload.data"
          :key="upload.id"
          class="uploadResult"
        >
          <div class="results-row d-flex" style="align-items: center">
            <a-icon
              type="clock-circle"
              theme="filled"
              v-if="upload.is_in_progress"
            />
            <a-icon
              type="check-circle"
              style="color: rgb(40, 167, 69)"
              theme="filled"
              v-else
            />

            <div
              :title="upload.file_name"
              :style="
                upload.is_in_progress
                  ? 'color:black;'
                  : 'color: #1890ff; cursor: pointer;'
              "
              @click="downloadExcel(upload)"
            >
              {{ upload.file_name }}
            </div>
            <div>{{ parseInt(upload.file_size / 1000) }} kb</div>
            <div :title="upload.upload_date">
              {{ moment(upload.upload_date).format("MM/DD/YYYY hh:mm A") }}
            </div>
            <div>
              <a v-b-toggle="`a${upload.id}`">
                summary <font-awesome-icon icon="angle-down" />
              </a>
            </div>
          </div>
          <b-collapse class="card" :id="`a${upload.id}`">
            <div class="p-3">
              <strong>{{
                parseInt(upload.points_awarded).toLocaleString()
              }}</strong>
              points awarded to
              <strong>{{
                parseInt(upload.users_awarded).toLocaleString()
              }}</strong>
              users.
              <strong
                >{{ parseInt(upload.users_unlocked).toLocaleString() }}
              </strong>
              users unlocked
              <strong>{{
                parseInt(upload.users_created.toLocaleString())
              }}</strong>
              new users created.
            </div>
          </b-collapse>
        </div>
        <a-pagination @change="allUpload.change" v-bind="allUpload" />
      </a-spin>
    </a-modal>
    <a-modal
      v-model="showUploadConfirm"
      title="Confirm Upload"
      :footer="null"
      width="720px"
      class="upload-confirm-modal"
      @cancel="showUploadConfirm = false"
    >
      <!-- Body -->
      <div class="modal-body">
        <h4>Are you sure?</h4>
        <p>
          A bulk action is about to be performed and will affect multiple users. The action may take up to 10 minutes to complete.<br/>
          You will receive a notification once finished.
        </p>
      </div>

      <!-- Footer -->
      <div class="modal-footer-custom">
        <a-button @click="showUploadConfirm = false">Cancel</a-button>
        <a-button type="primary" @click="confirmUpload">OK</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import { saveAs } from "file-saver";
import { mapState } from "vuex";
import { ChargeAndAllocate } from "@/api/funding";

export default {
  name: "BatchPointUploadTool",

  props: {
    activeMenuItem: String,
    activeMenu: String,
  },

  data() {
    return {
      saveUploadLoading: false,
      allowDups: false,
      file: null,
      showUploadConfirm: false,
      previousUpload: {
        data: [],
        pageSize: 5,
        loading: false,
      },
      allUpload: {
        data: [],
        pageSize: 10,
        hideOnSinglePage: true,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} items`,
        itemRender: (current, type, originalElement) => {
          return originalElement;
        },
        total: 0,
        change: (page, pageSize) => {
          this.getAllUpload(page, pageSize);
        },
        loading: false,
        visible: false,
      },
      usersToCreateFields: [
        {
          title: "Create",
          key: "create",
          dataIndex: "create",
          scopedSlots: { customRender: "create" },
          ellipsis: true,
        },
        {
          title: "User Name",
          key: "user_name",
          dataIndex: "user_name",
          scopedSlots: { customRender: "user_name" },
          ellipsis: true,
        },
        {
          title: "Email",
          key: "email",
          dataIndex: "email",
          scopedSlots: { customRender: "email" },
          ellipsis: true,
        },
        {
          title: "First Name",
          key: "first_name",
          dataIndex: "first_name",
          scopedSlots: { customRender: "first_name" },
          ellipsis: true,
        },
        {
          title: "Last Name",
          key: "last_name",
          dataIndex: "last_name",
          scopedSlots: { customRender: "last_name" },
          ellipsis: true,
        },
        {
          title: "Points",
          key: "points",
          dataIndex: "points",
          scopedSlots: { customRender: "points" },
          ellipsis: true,
        },
        {
          title: "Company",
          key: "company",
          dataIndex: "client_id",
          scopedSlots: { customRender: "company" },
          ellipsis: true,
        },
        {
          title: "Edit",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          ellipsis: true,
        },
      ],
      usersToUnlockFields: [
        {
          title: "User Name",
          key: "user_name",
          dataIndex: "user_name",
          scopedSlots: { customRender: "user_name" },
          ellipsis: true,
        },
        {
          title: "Unlock",
          key: "unlock",
          dataIndex: "unlock",
          scopedSlots: { customRender: "unlock" },
        },
        {
          title: "Reset points",
          key: "reset_points",
          dataIndex: "reset_points",
          scopedSlots: { customRender: "reset_points" },
        },
      ],
      usersToCreate: [],
      usersToUnlock: [],
      unlockedUsers: [],
      editusersToCreateId: "",
      usersToCreateFinalized: [],
      createUserForm: this.$form.createForm(this, { name: "createUserForm" }),
      usersToCreatePagination: {
        pageSize: 5,
        hideOnSinglePage: true,
      },
      usersToUnlockPagination: {
        pageSize: 5,
        hideOnSinglePage: true,
      },
    };
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
  },

  methods: {
     confirmUpload() {
        this.showUploadConfirm = false;
        this.uploadFile();
      },
    setActiveMenuItem: function () {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersBatchPointUploadTool",
        activeMenu: this.activeMenu ? this.activeMenu : "users",
      });
      // console.log(this.activeMenuItem);
    },
    getPreviousUpload(current, pageSize) {
      this.previousUpload.loading = true;
      this.$store
        .dispatch("adminBatchPointUpload/getUploads", {
          current: current,
          pageSize: pageSize,
          viewAllUploads: false,
        })
        .then((data) => {
          this.previousUpload = {
            ...this.previousUpload,
            loading: false,
            total: data.totalRecords,
            pageSize: pageSize,
            data: data.result,
          };
        });
    },
    getAllUpload(current, pageSize) {
      this.allUpload.loading = true;
      this.$store
        .dispatch("adminBatchPointUpload/getUploads", {
          current: current,
          pageSize: pageSize,
          viewAllUploads: true,
        })
        .then((data) => {
          this.allUpload = {
            ...this.allUpload,
            loading: false,
            total: data.totalRecords,
            pageSize: pageSize,
            data: data.result,
          };
        });
    },
    toggleAllUpload() {
      this.allUpload = { ...this.allUpload, visible: !this.allUpload.visible };
    },
    saveTemplate() {
      saveAs(new Blob([this.template]), "BatchPointUpload_template.xlsx");
    },
    beforeUpload(file) {
      this.file = file;
      return false;
    },
    uploadFile() {
      this.$store
        .dispatch("adminBatchPointUpload/uploadPointsFile", {
          file: this.file,
          allowDups: this.allowDups,
        })
        .then((uploadResult) => {
          if (uploadResult.batchUserPoints) {
            const filterdUsers = uploadResult.batchUserPoints
              .filter(({ action_type }) => action_type === "create")
              .map((user) => ({ ...user, create: true }));
            this.usersToCreate = filterdUsers;
            this.usersToCreateFinalized = filterdUsers;
            this.usersToUnlock = uploadResult.batchUserPoints.filter(
              ({ action_type }) => action_type === "unlock"
            );
            this.editusersToCreateId = "";
            this.unlockedUsers = [];
          }
          this.getPreviousUpload(1, this.previousUpload.pageSize);
          this.getAllUpload(1, this.allUpload.pageSize);
        })
        .catch((error) => {
          this.$error({
            title: "Error occured while uploading file",
            content: error,
          });
        });
    },
    handleChange(value, key, column) {
      const newData = [...this.usersToCreate];
      const target = newData.filter((item) => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.usersToCreate = newData;
      }
    },
    edit(key) {
      const newData = [...this.usersToCreate];
      const target = newData.filter((item) => key === item.id)[0];
      this.editusersToCreateId = key;
      if (target) {
        target.editable = true;
        this.usersToCreate = newData;
      }
    },
    save(key) {
      this.createUserForm.validateFields((errors, values) => {
        if (!errors || !values.create) {
          this.editusersToCreateId = "";
          const newData = [...this.usersToCreate];
          const newCacheData = [...this.usersToCreateFinalized];
          const target = newData.filter((item) => key === item.id)[0];
          Object.assign(target, {
            ...target,
            ...values,
            client_name: this.authorizedClients.find(
              ({ clientId }) => clientId.toString() === values.client_id
            ).clientName,
          });
          const targetCache = newCacheData.filter((item) => key === item.id)[0];
          if (target && targetCache) {
            delete target.editable;
            this.usersToCreate = newData;
            Object.assign(targetCache, target);
            this.usersToCreateFinalized = newCacheData;
          }
        }
      });
    },
    cancel(key) {
      const newData = [...this.usersToCreate];
      const target = newData.filter((item) => key === item.id)[0];
      this.editusersToCreateId = "";
      if (target) {
        Object.assign(
          target,
          this.usersToCreateFinalized.filter((item) => key === item.id)[0]
        );
        delete target.editable;
        this.usersToCreate = newData;
      }
    },
    cancelFileSave() {
      this.$confirm({
        title: "Cancel batch processing",
        content: "Are you sure to cancel? All uploaded data will be lost",
        okText: "Accept",
        okType: "danger",
        cancelText: "Go Back",
        onOk: () => {
          this.$store.dispatch(
            "adminBatchPointUpload/deleteUpload",
            this.lastUploads.at(-1).uploadResult.summary.id
          );
          this.$store.dispatch(
            "adminBatchPointUpload/updateFileUploadStatus",
            ""
          );
          this.file = null;
        },
      });
    },
    async savePointsUploadFile() {
      this.saveUploadLoading = true;
      const invalidCreate = this.usersToCreateFinalized.find(
        (user) =>
          user.create &&
          (!user.first_name ||
            !user.last_name ||
            !user.email ||
            !user.points ||
            !user.client_id)
      );
      if (invalidCreate) {
        const key = invalidCreate.id;
        const newData = [...this.usersToCreate];
        const target = newData.filter((item) => key === item.id)[0];
        this.editusersToCreateId = key;
        if (target) {
          target.editable = true;
          this.usersToCreate = newData;
        }
      } else {
        const { uploadResult } = this.lastUploads.at(-1);
        const finalizedUsers = this.usersToCreate.filter(
          ({ create }) => create
        );
        const payload = {
          id: uploadResult.summary.id,
          createBatchUserPoints: finalizedUsers,
          usersToUnlock: this.unlockedUsers,
        };

        // charge in stripe if a stripe customer
        /*if (this.stripeCustomerId) {
          try {
            const payload = {
              clientID: parseInt(this.userClients.client),
              receiptEmail: this.userEmail,
              description: "batch upload",
              byWhom: this.loggedInUserID,
              points: this.getPoints(),
            };
            const resp = await ChargeAndAllocate(payload);
            console.log(resp);

            if (resp.status != 200) {
              console.error("did not return 200");
              this.errorMessage = resp.data;
              this.saveUploadLoading = false
              return;
            }
          } catch (e) {
            console.error(
              `something went wrong allocating points and charging customer. ${e}`
            );
            this.saveUploadLoading = false
            this.errorMessage = e;
            return;
          }
        }*/
        this.$store
          .dispatch("adminBatchPointUpload/savePointsUploadFile", payload)
          .then(() => {
            this.getPreviousUpload(1, this.previousUpload.pageSize);
            this.getAllUpload(1, this.allUpload.pageSize);
            this.saveUploadLoading = false
          });
      }
    },
    closeFileSave() {
      this.$store.dispatch("adminBatchPointUpload/updateFileUploadStatus", "");
      this.file = null;
    },
    setUnlockedUsers(recordId) {
      if (this.unlockedUsers.includes(recordId)) {
        this.unlockedUsers = this.unlockedUsers.filter((id) => id !== recordId);
      } else {
        this.unlockedUsers = [...this.unlockedUsers, recordId];
      }
    },
    downloadExcel(upload) {
      this.$store
        .dispatch("adminBatchUserUploadTool/downloadExcelFile", {
          ft: "batchpointuploadtool",
          id: upload.id,
        })
        .then((data) => {
          saveAs(new Blob([data]), `${upload.file_name}.xls`);
        })
        .catch((err) => {
          alert(err.data.message);
        });
    },
    getPoints() {
      return this.lastUploads
        .at(-1)
        .uploadResult.batchUserPoints.reduce((value, entry) => {
          if (entry.action_type === "ok") return value + entry.points;
          else return value;
        }, 0);
    },
  },
  computed: {
    ...mapState({
      userDetail: (state) => state.userManager.userDetail,
      companyName: (state) => state.company.name,
      stripeCustomerId: (state) => state.company.stripeCustomerId,
      ratio: (state) => state.company.ratio,
      userClients: (state) => state.user.userClients,
      loggedInUserID: (state) => state.user.profile.id,
      userEmail: (state) => state.user.email,
      unallocDeposit: (state) => state.company.unallocDeposit,
    }),

    authorizedClients() {
      return this.$store.getters["adminBatchPointUpload/getAuthorizedClients"];
    },
    template() {
      return this.$store.getters["adminBatchPointUpload/getTemplate"];
    },
    fileUploadStatus() {
      return this.$store.getters["adminBatchPointUpload/getFileUploadStatus"];
    },
    lastUploads() {
      return this.$store.getters["adminBatchPointUpload/getLastUploads"];
    },
    fileList() {
      return this.file ? [this.file] : [];
    },
  },

  async created() {
    this.setActiveMenuItem();
    this.getPreviousUpload(1, this.previousUpload.pageSize);
    this.getAllUpload(1, this.allUpload.pageSize);
    this.$store.dispatch("adminBatchPointUpload/fetchAuthorizedClients");
    this.$store.dispatch("adminBatchPointUpload/getTemplate");

    await this.$store.dispatch("company/fetchCompany"); // TODO all of these things should be persistent
    await this.$store.dispatch("user/fetchProfile");

    // Reload page confirmation when uploading
    window.addEventListener("beforeunload", (e) => {
      if (
        this.fileUploadStatus === "saving" ||
        this.fileUploadStatus === "uploading" ||
        this.previousUpload.loading ||
        this.allUpload.loading
      ) {
        e.returnValue = "Still Waiting!";
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.admin-batch-point-upload-tool {
  margin: -0.5% 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
  a {
    color: #1890ff;
    &:hover {
      color: #40a9ff;
    }
  }
}
.align-right {
  text-align: right;
}

.bold-text {
  font-weight: bold;
}

.display-flex {
  display: flex;
}

.marginAll {
  margin: 10px;
}

.card {
  background-image: url(https://new.incentiveweb.com/img/bg-blue.75d34f7d.svg);
  max-width: 100%;
  border-radius: $border-radius-sm;
  background-position: top center;
  background-repeat: repeat;
  background-size: 90px;
  background-color: #f0f9ff;
}

.summary .custom-control-label::before {
  background-color: white;
}
.summary .custom-control-label {
  line-height: 1.1em;
}
.results-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.5%;
  padding-right: 1%;
}
.uploadResult {
  margin-bottom: 2%;
  border-bottom: 0.5px solid #f2f2f2;
  padding-bottom: 1%;
}
.results-row > div {
  flex-basis: 10%;
}
.results-row > div:nth-child(1) {
  flex-basis: 5%;
}
.results-row > div:nth-child(2),
.results-row > div:nth-child(4) {
  flex-basis: 30%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.fileUploadResultAction {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.lastUploadsHeader {
  display: flex;
  justify-content: space-between;
}
.editable-row-operations span {
  display: flex;
  justify-content: space-evenly;
}
</style>
<style lang="scss">
.admin-batch-point-upload-tool,
.ant-modal-content {
  .ant-pagination {
    .ant-pagination-next,
    .ant-pagination-total-text {
      display: block;
    }
    .ant-pagination-total-text {
      margin-right: auto;
    }
  }
}
.ant-pagination {
  display: flex;
  justify-content: flex-end;
  padding-right: 1%;
  margin-top: 5%;
}
.ant-upload-list.ant-upload-list-text {
  vertical-align: sub;
  display: inline-block;
}
.ant-select-selection.ant-select-selection--single {
  min-width: 6em;
}
.ant-form-explain {
  width: 7.5em;
  white-space: pre-wrap;
}
/* ============================
   Confirmation Modal Styling
   ============================ */

.upload-confirm-modal .ant-modal-content {
  border-radius: 14px !important;
  padding: 0 !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

/* Title Bar */
.upload-confirm-modal .modal-title {
  font-size: 18px;
  font-weight: 700;
  padding: 18px 22px;
  border-bottom: 1px solid #eee;
  background: #fdfdfd;
}

/* Body Text Section */
.upload-confirm-modal .modal-body {
  padding: 20px 22px 12px 22px;
}

.upload-confirm-modal .modal-text {
  font-size: 15px;
  margin: 0 0 8px 0;
  color: #444;
  line-height: 1.45;
}

/* Button Footer Section */
.upload-confirm-modal .modal-footer-custom {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 22px 22px 22px;
  border-top: 1px solid #f2f2f2;
}

/* Buttons */
.upload-confirm-modal .ant-btn {
  height: 34px;
  font-size: 14px;
  padding: 0 18px;
  border-radius: 6px;
}

.upload-confirm-modal .ant-btn-primary {
  background: #1677ff !important;
  border-color: #1677ff !important;
  box-shadow: none !important;
}

/* Cancel button hover */
.upload-confirm-modal .ant-btn:hover {
  opacity: 0.92;
}

</style>
